export const truncateText = (text: string, maxLength: number = 10) => {
  if (text.length <= maxLength) return text;
  const start = Math.floor(maxLength / 2);
  const end = text.length - Math.floor(maxLength / 2);
  return `${text.substring(0, start)}...${text.substring(end)}`;
};

export const copyToClipboard = async (text?: string) => {
  try {
    const toCopy = text || "";
    await navigator.clipboard.writeText(toCopy);
  } catch (err) {
    console.error("Failed to copy: ", err);
  }
};
